<template>
  <div class="bg-white rounded-xl border border-gray-200 overflow-hidden">
    <div class="px-5 py-4 border-b border-gray-100">
      <h3 class="text-sm font-semibold text-gray-700">{{ title }}</h3>
    </div>

    <!-- Loading -->
    <div v-if="loading" class="p-8 flex justify-center">
      <div class="w-7 h-7 border-3 border-gray-200 border-t-primary rounded-full animate-spin"></div>
    </div>

    <!-- Error -->
    <div v-else-if="error" class="p-8 text-center">
      <p class="text-sm text-red-500 mb-2">{{ error }}</p>
      <button @click="$emit('retry')" class="text-xs text-primary font-medium hover:underline">Reessayer</button>
    </div>

    <!-- Empty -->
    <div v-else-if="!hasData" class="p-8 text-center text-sm text-gray-400">
      Aucune donnee
    </div>

    <!-- Table content -->
    <div v-else class="overflow-x-auto">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardTableWrapper',
  props: {
    title: String,
    loading: Boolean,
    error: String,
    hasData: { type: Boolean, default: true }
  },
  emits: ['retry']
}
</script>
